import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import FormatQuoteIcon from '@mui/icons-material/FormatQuoteOutlined';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    backgroundColor: 'rgba(245, 245, 245, 0.3)',
  },
  container: {
    maxWidth: '1280px',
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(8),
    animation: '$fadeIn 0.6s ease-out',
  },
  title: {
    fontSize: '2.25rem',
    fontWeight: 700,
    color: '#121212',
    [theme.breakpoints.up('md')]: {
      fontSize: '2.25rem',
    },
  },
  testimonialCard: {
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(4),
    borderRadius: '12px',
    border: '2px solid #F5F5F5',
    transition: 'all 0.3s ease',
    height: '100%',
    position: 'relative',
    animation: '$fadeInUp 0.8s ease-out',
    '&:hover': {
      borderColor: '#D91A5B',
      boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    },
  },
  quoteIcon: {
    fontSize: '40px',
    color: 'rgba(217, 26, 91, 0.2)',
    marginBottom: theme.spacing(2),
  },
  quote: {
    color: '#616161',
    lineHeight: 1.7,
    marginBottom: theme.spacing(3),
  },
  authorSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  avatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#D91A5B',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
  },
  authorName: {
    fontWeight: 600,
    color: '#121212',
  },
  authorRole: {
    fontSize: '0.875rem',
    color: '#616161',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

const testimonials = [
  {
    name: 'Dr. Sarah Chen',
    role: 'Molecular Biologist, Stanford University',
    content:
      'Mind The Graph transformed how I create diagrams for my publications. The library is comprehensive and the editor is incredibly intuitive.',
    avatar: 'SC',
  },
  {
    name: 'Prof. Michael Rodriguez',
    role: 'Neuroscience Researcher, MIT',
    content:
      'The AI-generated illustrations save me hours of work. The quality is exceptional and perfect for high-impact journals.',
    avatar: 'MR',
  },
  {
    name: 'Dr. Lisa Patel',
    role: 'PhD Student, Oxford University',
    content:
      'As a student, the free tier is perfect for my thesis. The templates gave me a professional head start on my diagrams.',
    avatar: 'LP',
  },
];

export default function Testimonials() {
  const classes = useStyles();

  return (
    <section className={classes.section}>
      <Container className={classes.container}>
        <Box className={classes.header}>
          <Typography className={classes.title} component="h3">
            500K+ Academics Trust Mind The Graph
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                className={classes.testimonialCard}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <FormatQuoteIcon className={classes.quoteIcon} />
                <Typography className={classes.quote}>"{testimonial.content}"</Typography>
                <Box className={classes.authorSection}>
                  <Box className={classes.avatar}>{testimonial.avatar}</Box>
                  <Box>
                    <Typography className={classes.authorName}>{testimonial.name}</Typography>
                    <Typography className={classes.authorRole}>{testimonial.role}</Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
}
